import React, { useRef, useState } from "react";
import type { Destination } from "@whatslly/types/messages-server/destinations";
import { DEFAULT_LAKE_SYNC_MINUTES, DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import { FormElement } from "@whatslly/ui-components/v2/FormElements/Form";
import { FormikProps } from "formik";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { useTranslation } from "react-i18next";
import type { DestinationFormProps, FormDestinationDataType } from "../utils/DestinationsListTypes";
import { LakeField, validateLake } from "../components/LakeField";
const BASE_DATA: Destination = {
  type: "internalS3" as const,
  integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  settings: {} as Record<string, string>,
};

type FormDataType = FormDestinationDataType<"internalS3">;

export const InternalS3ModalForm: React.FC<DestinationFormProps<"internalS3">> = ({ onSubmitForm, settings, lake }) => {
  const { t } = useTranslation();
  const formikContext = useRef<FormikProps<FormDataType>>(null);
  const [formikErrorHasErrors, setFormikErrorHasErrors] = useState(false);

  const validate = (values: FormDataType) => {
    const errors = validateLake(values, t);
    setFormikErrorHasErrors(Object.keys(errors).length > 0);
    return errors;
  };

  return (
    <FormElement
      initialValues={settings || { lakeSyncMinutes: DEFAULT_LAKE_SYNC_MINUTES }}
      validate={validate}
      onSubmit={(data) => onSubmitForm({ ...BASE_DATA, settings: { ...data } })}
      formikRef={formikContext}
    >
      <div>Save to enable internal Custom S3 integration</div>
      <LakeField type="internalS3" state={lake} isNewDestination={!settings} />
      <ModalButtons
        submitText={t("destinations_page.save")}
        testId={"destination-ok-button"}
        isSubmitDisabled={formikErrorHasErrors}
        onSubmit={() => formikContext.current?.submitForm()}
        hideCancel={true}
      />
    </FormElement>
  );
};
